import { render, staticRenderFns } from "./ServiceCard.vue?vue&type=template&id=82ac4804&scoped=true"
import script from "./ServiceCard.vue?vue&type=script&lang=ts"
export * from "./ServiceCard.vue?vue&type=script&lang=ts"
import style0 from "./ServiceCard.vue?vue&type=style&index=0&id=82ac4804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ac4804",
  null
  
)

export default component.exports